import React, { Component } from "react";
import FestivosForm from "../FestivosForm/FestivosForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : CardPage
Description : Componente que contienen el formulario de la pantalla Card 
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina – Se llama al componente CardForm
================================================================================ */
class FestivosPage extends Component{
    render(){
        return(
            <div>                    
                <FestivosForm/>
            </div>
        )   
    }
}

export default FestivosPage;